import { createGlobalStyle } from "styled-components"
import media from "src/styles/media"
import fonts from "./fonts"
import animations from "./animations"

const GlobalStyles = createGlobalStyle`

${fonts}

${animations}

body{
	max-height: 100vh;
	overflow-x: hidden;
	font-family: 'Basis Grotesque Pro', sans-serif;
	font-weight: 400;
	color: #fff;
	
	
		--primary: #f9264f;
		--primary--darken: #bd1938;
		--secondary: #21dfe8;
		--green: #25D366;
		--dark: #14073a;
		--navy: #14195c;
		--white: #fff;

	::-webkit-scrollbar {
		width: 10px;
	}

	/* Track */
	::-webkit-scrollbar-track {
		background: #f1f1f1;
	}
	
	/* Handle */
	::-webkit-scrollbar-thumb {
		background: #120633;
		border-radius: 15px;
		border: 2px solid rgba(0, 0, 0, 0);
 		background-clip: padding-box;
	}

	/* Handle on hover */
	::-webkit-scrollbar-thumb:hover {
		background: #120633;
		border-radius: 15px;
		border: 1.6px solid rgba(0, 0, 0, 0);
 		background-clip: padding-box;
	}
}

button{
	&:focus{
		outline: none;
	}
}

@media screen and (max-width: 992px){
	.container-mobile-full{
		margin: 0 !important;
		padding: 0 !important;
		max-width: unset !important;
	}
}

[data-reach-dialog-overlay]{
	z-index: 999;
}

._2qp0Z{
	z-index: 10000;
}

${media.lessThan("lg")`
	._1mXIm{
		max-width: 80%;
	}

	._Muogh{
		display: block;
		margin-top: 2px;
		max-width: 80%;
	}

	._2uc4w{
		padding: 6px 0;
	}
`}
`

export default GlobalStyles
